<template>
  <div>
    <v-toolbar flat height="60" dark color="primary">
      <v-layout align-center>
        <v-btn fab x-small color="white" depressed @click="onClose()">
          <v-icon class="primary--text">close</v-icon>
        </v-btn>
        <v-toolbar-title v-if="type == 'new'" class="hidden-xs-only white--text pl-2">新規</v-toolbar-title>
        <v-toolbar-title v-else-if="type == 'edit'" class="hidden-xs-only white--text pl-2">編集</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-chip
            :color="getStatusColor()"
            text-color="white">{{ '最終ステータス：' + getStatus(tempUser) }}
          </v-chip>
        </v-toolbar-items>
      </v-layout>
    </v-toolbar>
    <v-card tile elevation="0" class='overflow-y-auto' :style="contentsHeight">
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="2" class="pa-0">
            <v-text-field
              v-if="tempUser"
              prepend-icon="person"
              label="名前"
              class="mr-1"
              :value="tempUser.name != 'null' ? tempUser.name : tempUser.seiY"
              readonly
              hideDetails
            ></v-text-field>
          </v-col>
          <v-col cols="1" class="pa-0">
            <v-text-field
              v-if="tempUser && tempUser.tyg"
              label="YCS"
              class="mx-1"
              :value="getYCS(tempUser)"
              readonly
              hideDetails
              color="secondary"
            ></v-text-field>
          </v-col>
          <v-col cols="8" class="pa-0">
          </v-col>
          <v-col cols="8" class="pa-0">
            <v-col cols="12">
              <app-personal-dialog
                :item="tempUser"
                :check="check"
                :type="type"
                @updated="onUpdated"
              >
              </app-personal-dialog>
            </v-col>
            <v-col cols="12" class="pa-0">
              <v-toolbar v-if="tempUser.status <= $STATUS_ADMISSION && type == 'edit'" color="success" height="48" dark class="elevation-0">
                <v-toolbar-title class="subheading">対応</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn v-if="tempUser.status < 5" :disabled="!isModified" outlined rounded depressed @click="onCancel()">取消</v-btn>
                <v-btn v-if="tempUser.status < 5" :disabled="!isModified" rounded depressed color="error" @click="onStore()">保存</v-btn>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pb-0 pt-1 px-0">
              <v-stepper v-if="tempUser.status < $STATUS_ADMISSION" v-model="tempUser.status">
                <v-stepper-header>
                  <v-stepper-step color="success" :complete="tempUser.status > 1" step="1">問合せ</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step color="success" :complete="tempUser.status > 2" step="2">保護者面談</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step color="success" :complete="tempUser.status > 3" step="3">体験授業</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step color="success" :complete="tempUser.status > 4" step="4">提案</v-stepper-step>
                  <v-divider></v-divider>
                  <v-stepper-step color="success" step="5">{{ extension == 1 ? '入会' : '入塾' }}</v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                  <v-stepper-content step="1" class="pa-1">
                    <app-process-template
                      v-if="tempUser.status == '1'"
                      :user="tempUser"
                      type="1"
                      :item="event"
                      :files="files"
                      :isModifiedEvent="isModifiedEvent"
                      @next="onNext"
                      @prev="onPrev"
                      @secession="onFail"
                      @store="onStore"
                      @update="onUpdateEvent"
                      @delete="onDelete">
                    </app-process-template>
                  </v-stepper-content>
                  <v-stepper-content step="2" class="pa-1">
                    <app-process-template
                      v-if="tempUser.status == '2'"
                      :user="tempUser"
                      type="2"
                      :item="event"
                      :files="files"
                      :isModifiedEvent="isModifiedEvent"
                      @next="onNext"
                      @prev="onPrev"
                      @update="onUpdateEvent"
                      @secession="onFail"
                      @delete="onDelete">
                    </app-process-template>
                  </v-stepper-content>
                  <v-stepper-content step="3" class="pa-1">
                    <app-process-template
                      v-if="tempUser.status == '3'"
                      :user="tempUser"
                      type="3"
                      :item="event"
                      :files="files"
                      :isModifiedEvent="isModifiedEvent"
                      @next="onNext"
                      @prev="onPrev"
                      @update="onUpdateEvent"
                      @secession="onFail"
                      @delete="onDelete">
                    </app-process-template>
                  </v-stepper-content>
                  <v-stepper-content step="4" class="pa-1">
                    <app-process-template
                      v-if="tempUser.status == '4'"
                      :user="tempUser" type="4"
                      :item="event"
                      :files="files"
                      :isModifiedEvent="isModifiedEvent"
                      @next="onNext"
                      @prev="onPrev"
                      @update="onUpdateEvent"
                      @secession="onFail"
                      @delete="onDelete">
                    </app-process-template>
                  </v-stepper-content>
                  <v-stepper-content step="5" class="pa-1">
                    <app-process-template
                      v-if="tempUser.status == '5'"
                      :user="tempUser"
                      type="5"
                      :item="event"
                      :files="files"
                      :isModifiedEvent="isModifiedEvent"
                      @next="onNext"
                      @prev="onPrev"
                      @update="onUpdateEvent"
                      @secession="onFail"
                      @admission="onSuccessDialog"
                      @delete="onDelete">
                    </app-process-template>
                  </v-stepper-content>
                </v-stepper-items>
              </v-stepper>
            </v-col>
            <v-col cols="12" class="pa-0">
              <app-action-template
                v-if="tempUser.status == $STATUS_ADMISSION && type == 'edit'"
                :type="type"
                :item="event"
                :user="tempUser"
                @submitEvent="onEventSubmit"
              >
              </app-action-template>
            </v-col>
          </v-col>
          <v-col cols="4" class="pa-0">
            <v-col cols="12" class="px-1">
              <v-toolbar flat color="success" height="48" dark>
                <v-row align="center">
                  <v-col cols="3" class="py-0" align="start">
                    <span class="title">履歴</span>
                  </v-col>
                  <v-col cols="9" class="py-0" align="center">
                    <v-text-field
                      v-model="search"
                      append-icon="search"
                      hide-details
                      clearable
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-toolbar>
            </v-col>
            <v-col cols="12" class="pa-0 px-1">
              <v-row class="ma-0" align="center" justify="center">
                <template v-for="(header, index) in headers">
                  <v-col :cols="header.width" :class="'customHeader pa-0'" :key="header.key" :align="header.align">
                    <template v-if="header.key == 'typeName'">
                      <v-select
                        class="mx-1 caption"
                        dense
                        :items='types'
                        v-model='typeFilter'
                        hide-details
                        item-text="name"
                        item-value="key"
                      ></v-select>
                    </template>
                    <template v-else>
                      <span @click="onSort(index)" class="pa-0 caption" @mouseenter="onMouse(index, true)" @mouseleave="onMouse(index, false)">{{ header.title }}</span>
                      <v-icon class="pa-0 ma-0" :color="headers[index].over ? 'grey' : 'transparent'" >{{ getSortIcon(index) }}</v-icon>
                      <template v-if="header.key == 'chargeName'">
                        <v-icon small @click="onExpandAll()" color="success" class="pa-0 ma-0">{{ expandsAll ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      </template>
                    </template>
                  </v-col>
                </template>
              </v-row>
            </v-col>
            <v-col cols="12" class="pa-0 py-1">
              <v-divider class="mx-2"></v-divider>
            </v-col>
            <v-col cols="12" class="pa-0">
              <div class='overflow-y-auto' :style="rContentsHeight">
                <v-list class="ma-0 pa-0">
                  <v-list-item
                    v-for="(item, index) in myEvents"
                    :key="index"
                    dense
                    class="ma-0 pa-0"
                  >
                    <v-col cols="12" @click.right="onExpand($event, item)" class="pt-0 pb-0 px-1 customLine" :key="index">
                      <v-row @click.stop="status = item, statusDialog = true" class="ma-0" align="center" justify="start" style="min-height: 34px;">
                        <v-col cols="3" class="pa-0 pl-1" align="center">
                          <span class="select-none caption" :style="item.status !== 1 && item.date1 ? 'color: #43A047;' : ''">{{ item.responseDate }}</span>
                        </v-col>
                        <v-col cols="6" class="pa-0 history">
                          <span class="select-none caption">{{ item.typeName }}</span>
                        </v-col>
                        <v-col cols="2" class="pa-0 pb-1" align="start">
                          <v-chip x-small :color="getChargeColor(item)" text-color="white" class="history">
                            <span class="select-none">{{ item.chargeName }}</span>
                          </v-chip>
                        </v-col>
                        <v-col cols="1" class="pa-0 history">
                          <v-tooltip v-if="item.memo" bottom color="transparent">
                            <template v-slot:activator="{ on }">
                              <v-icon v-on="on" color="success" size="20">mdi-pencil-box</v-icon>
                            </template>
                            <v-card class="pa-0" width="200">
                              <v-card-text class="pa-1 caption">
                                <span>{{ item.memo }}</span>
                              </v-card-text>
                            </v-card>
                          </v-tooltip>
                        </v-col>
                        <v-col v-if="item.attaches && item.attaches.length != 0" cols="12" class="pa-0">
                          <template v-for="(file, index) in item.attaches">
                            <v-row :key="index" class="ma-0" align="center">
                              <v-col cols="2" class="py-0 pl-3 pr-0" align="end">
                                <v-icon small :color="file.mime == 'application/pdf' ? 'error' : ''">{{ $MIMEICON[file.mime] }}</v-icon>
                              </v-col>
                              <v-col cols="8" class="py-0 px-1">
                                <v-chip x-small color="secondary" outlined @click.stop="onClick(file)">
                                  <span class="overflow-text-hidden">{{ file.name }}</span>
                                </v-chip>
                              </v-col>
                              <v-col cols="2" class="pa-0">
                                <span style="font-size:10px;" class="grey--text">{{ file.size }}</span>
                              </v-col>
                            </v-row>
                          </template>
                        </v-col>
                        <v-col v-if="expands[item.id]" cols="12" class="ma-0 pt-0 pb-0 pl-3">
                          <v-card v-if="getMemo(item) != ''" outlined>
                            <v-card-text class="memo caption pa-1" @click="status = item, statusDialog = true">
                              <span style="white-space:pre-wrap;">{{ getMemo(item) }}</span>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-list-item>
                </v-list>
              </div>
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <div>
      <app-basic-dialog
        @dismissed="onDismissed"
        :title="extension == 1 ? '入会' : '入塾'"
        :message="extension == 1 ? '対応状況を入会へ変更します。よろしいですか?' : '対応状況を入塾へ変更します。よろしいですか?'"
        :dialog='admissionDialog'
        color="success"
        :cancel='true'>
      </app-basic-dialog>
    </div>

    <div class="text-center">
      <v-layout row justify-center>
        <v-dialog
          v-model='statusDialog'
          persistent
          max-width="400px">
          <app-status-dialog
            v-if="statusDialog"
            @dismissed="onDismissed"
            :event="status"
            :item="tempUser"
            :type="type"
            @update="onUpdateEvent"
            >
          </app-status-dialog>
        </v-dialog>
      </v-layout>
    </div>

    <div>
      <app-loading :loading="loading"></app-loading>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment-timezone'
import { mapGetters } from 'vuex'
import * as async from 'async'

import ProcessTemplate from './ProcessTemplate.vue'
import ActionTemplate from './ActionTemplate.vue'
import PersonalDialog from './PersonalDialog.vue'
import StatusDialog from './StatusDialog.vue'
Vue.component('app-process-template', ProcessTemplate)
Vue.component('app-action-template', ActionTemplate)
Vue.component('app-personal-dialog', PersonalDialog)
Vue.component('app-status-dialog', StatusDialog)
export default {
  computed: {
    ...mapGetters({
      user: 'auth/user',
      data: 'auth/data',
      users: 'users/users',
      groups: 'groups/groups',
      schools: 'schools/schools',
      scholae: 'scholae/scholae',
      students: 'students/students',
      windowSize: 'shared/windowSize',
      extension: 'shared/extension'
    }),
    form () {
      return {
        sei: this.tempUser.sei,
        mei: this.tempUser.mei,
        seiY: this.tempUser.seiY,
        meiY: this.tempUser.meiY
      }
    },
    types () {
      var temp = []
      temp.push({ name: '全種別', key: '*' })
      for (var i in this.tempUser.events) {
        if (this.tempUser.events[i].enable) {
          var type = this.tempUser.events[i].status
          if (type === 6) {
            type += this.tempUser.events[i].type + 2
          }
          if (this.extension === 1) {
            temp.push({ name: this.typeDefine_1[type], key: type })
          } else {
            temp.push({ name: this.typeDefine[type], key: type })
          }
        }
      }
      temp.sort(function (a, b) {
        if (a.key > b.key) return 1
        if (a.key < b.key) return -1
        return 0
      })
      return temp
    },
    myEvents () {
      var temp = []
      for (var i in this.tempUser.events) {
        var payload = JSON.parse(JSON.stringify(this.tempUser.events[i]))
        if (this.tempUser.events[i].enable) {
          var type = this.tempUser.events[i].status
          if (type === 6) {
            type += this.tempUser.events[i].type + 2
          }
          if (this.typeFilter === '*' || this.typeFilter === type) {
            payload['typeId'] = type
            payload['responseDate'] = this.getTime(this.tempUser.events[i])
            payload['typeName'] = this.getAction(this.tempUser.events[i])
            payload['chargeName'] = this.getCharge(this.tempUser.events[i])
            payload['expanded'] = false
            if (this.search) {
              if (this.getMemo(payload).indexOf(this.search) !== -1) {
                temp.push(payload)
              } else {
                for (var x in this.tempUser.events[i].attaches) {
                  if (this.tempUser.events[i].attaches[x].name.indexOf(this.search) !== -1) {
                    temp.push(payload)
                  }
                }
              }
            } else {
              temp.push(payload)
            }
          }
        }
      }
      var key = null
      for (i in this.headers) {
        if (this.headers[i].value) {
          key = this.headers[i].key
          if (this.headers[i].value === 1) {
            temp.sort(function (a, b) {
              if (a[key] > b[key]) return -1
              if (a[key] < b[key]) return 1
              return 0
            })
          } else {
            temp.sort(function (a, b) {
              if (a[key] < b[key]) return -1
              if (a[key] > b[key]) return 1
              return 0
            })
          }
          break
        }
      }
      return temp
    },
    isModified () {
      var status = false
      if (this.tempUser.key) {
        if (this.tempUser.status !== 5) {
          status = this.isModifiedEvent
        }
      }
      return status
    },
    contentsHeight () {
      return 'height: ' + String(this.windowSize.y - 60 - 1) + 'px;'
    },
    rContentsHeight () {
      return 'background: transparent; height: ' + String(this.windowSize.y - 60 - 68 - 48 - 48 - 1) + 'px;'
    }
  },
  watch: {
    tempUser () {
      this.createEvents()
    },
    item () {
      this.tempUser = JSON.parse(JSON.stringify(this.item))
    }
  },
  data () {
    return {
      expands: {},
      expandsAll: false,
      rules: {
        required: value => !!value || '必須'
      },
      event: null,
      loading: false,
      statusDialog: false,
      status: null,
      dialog8: false,
      admissionDialog: false,
      dialog5: false,
      tempItem: null,
      check: false,
      formHasErrors: false,
      group: null,
      school: null,
      tempUser: null,
      search: null,
      isModifiedEvent: false,
      files: [],
      typeFilter: '*',
      headers: [
        { over: false, value: 0, title: '日付', key: 'responseDate', width: '3', align: 'center' },
        { over: false, value: 0, title: '種別', key: 'typeName', width: '6', align: 'start' },
        { over: false, value: 0, title: '記入', key: 'chargeName', width: '3', align: 'center' }
      ],
      typeDefine: { 1: '問合せ', 2: '保護者面談', 3: '体験授業', 4: '提案', 5: '入塾', 6: '在籍', 7: '退塾', 8: '逸失', 9: 'DTS', 10: '生徒面談', 11: '保護者面談', 12: 'YCS', 13: '約束', 14: '退塾', 15: 'その他' },
      typeDefine_1: { 1: '問合せ', 2: '保護者面談', 3: '体験授業', 4: '提案', 5: '入会', 6: '在籍', 7: '退会', 8: '逸失', 9: 'DTS', 10: '生徒面談', 11: '保護者面談', 12: 'YCS', 13: '約束', 14: '退会', 15: 'その他' },
      sortIcons: [
        'mdi-menu-swap',
        'mdi-menu-down',
        'mdi-menu-up'
      ]
    }
  },
  props: [ 'item', 'dialog', 'type' ],
  created () {
    this.tempUser = JSON.parse(JSON.stringify(this.item))
    this.createEvents()
    var keys = Object.keys(this.tempUser.groups)
    for (var i in keys) {
      if (this.tempUser.groups[keys[i]]) {
        this.group = keys[i]
      }
    }
    if (!this.tempUser.charge) {
      this.tempUser.charge = this.user.uid
    }
    this.descriptions = JSON.parse(JSON.stringify(this.$DESCRIPTIONS_ITEMS))
    keys = Object.keys(this.data.schools)
    for (i in keys) {
      if (this.data.schools[keys[i]]) {
        var index = this.schools.findIndex(school => school.key === keys[i])
        if (index !== -1) {
          this.school = this.schools[index]
        }
      }
    }
  },
  methods: {
    createEvents () {
      if (this.tempUser) {
        const index = this.tempUser.events.findIndex(event => event.status === this.tempUser.status)
        if (index !== -1 && this.tempUser.status !== this.$STATUS_ADMISSION && this.tempUser.events[index].enable) {
          this.event = this.tempUser.events[index]
        } else {
          this.event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
          this.event.status = this.tempUser.status
          this.event.key = this.tempUser.key
        }
      }
    },
    getDate (item) {
      return moment.unix((item.updatedAt / 1000)).format('YYYY-MM-DD')
    },
    getYCS (item) {
      const index = this.$YCSS.findIndex(tyg => tyg.key === item.tyg)
      if (index !== -1) {
        return this.$YCSS[index].name
      }
      return 'N/A'
    },
    getTime (item) {
      var m = moment(item.createdAt)
      if (item.status === 1) {
        m = moment(item.updatedAt)
      } else if (item.date1) {
        m = moment(item.date1)
      }
      return m.format('YY/MM/DD')
    },
    getStatus (item) {
      var index = this.$STATUS.findIndex(status => status.key === item.status)
      if (index !== -1) {
        return this.$STATUS[index].name
      }
      return ''
    },
    getAction (item) {
      if (item.status < this.$STATUS_ADMISSION || item.status > this.$STATUS_ADMISSION) {
        var index = this.$STATUS.findIndex(status => status.key === item.status)
        if (index !== -1) {
          if (item.status === 5) {
            return this.$STATUS[index].name
          } else {
            return this.$STATUS[index].name
          }
        }
      } else if (item.status === this.$STATUS_ADMISSION) {
        index = this.$ACTIONS.findIndex(action => action.key === item.type)
        if (index !== -1) {
          if (item.type === 4) {
            return this.$ACTIONS[index].name + '（' + this.getYCS(item) + '）'
          }
          return this.$ACTIONS[index].name
        }
      }
      return ''
    },
    getChargeColor (item) {
      if (item.status < this.$STATUS_ADMISSION) {
        return 'grey'
      } else {
        return 'primary'
      }
    },
    getCharge (item) {
      const index = this.users.findIndex(user => user.key === item.charge)
      if (index !== -1) {
        return this.users[index].sei
      }
      return ''
    },
    getContent (item) {
      if (item.type === 1 || item.type === 2 || item.type === 5) {
        return item.date1
      }
      if (item.type === 6) {
        return item.date1
      }
      if (item.type === 4) {
        return item.tyg
      }
      if (item.type === null && item.status === this.$STATUS_ADMISSION) {
        return item.date1
      }
      return ''
    },
    getMemo (item) {
      if (!item.memo) {
        return ''
      }
      return item.memo
    },
    onClick (file) {
      if (file.path) {
        window.open(file.path, '_blank')
      } else {
        window.open(URL.createObjectURL(file.blob), '_blank')
      }
    },
    onCancel () {
      this.createEvents()
      this.files = []
      this.isModifiedEvent = false
    },
    onContactAdd () {
      this.item = JSON.parse(JSON.stringify(this.$store.getters['students/contact']))
      this.dialog5 = true
    },
    onEditContact (item) {
      this.item = item
      this.dialog5 = true
    },
    onUpdated: function (value) {
      if (value) {
        this.tempUser = value
        this.isModifiedEvent = false
      }
    },
    getLatestYCS (item) {
      var ycs = null
      for (var i in item.events) {
        if (item.events[i].enable && item.events[i].type === 4) {
          ycs = item.events[i].tyg
          break
        }
      }
      return ycs
    },
    onExpand (e, item) {
      e.preventDefault()
      if (this.expands[item.id] !== 'undefined') {
        Vue.set(this.expands, item.id, !this.expands[item.id])
      } else {
        this.expands[item.id] = true
      }
    },
    onExpandAll () {
      this.expandsAll = !this.expandsAll
      for (var i in this.myEvents) {
        Vue.set(this.expands, this.myEvents[i].id, this.expandsAll)
        // this.expands[this.myEvents[i].id] = this.expandsAll
      }
    },
    onDismissed: function (value) {
      if (this.admissionDialog) {
        this.admissionDialog = false
        if (value) {
          this.onSuccess()
        }
        return
      }
      var vm = this
      if (this.statusDialog) {
        this.statusDialog = false
        if (value) {
          if (value.action === 'remove') {
            for (var i in this.tempUser.events) {
              if (this.tempUser.events[i].id === value.event.id) {
                this.tempUser.events[i].enable = false
                this.tempUser.events[i].counter += 1
                if (this.tempUser.events[i].status === 5) {
                  this.tempUser.status = 5
                  this.tempUser.admission = null
                  for (var z in this.tempUser.events) {
                    if (this.tempUser.events[z].status > 5) {
                      this.tempUser.events[z].enable = false
                      if (this.tempUser.events[z].status === 7) {
                        this.tempUser.graduation = null
                      }
                      if (this.tempUser.events[z].status === 8) {
                        this.tempUser.secession = null
                      }
                    }
                  }
                } else if (this.tempUser.events[i].status === 7) {
                  this.tempUser.status = 6
                  this.tempUser.graduation = null
                } else if (this.tempUser.events[i].status === 8) {
                  for (var x in this.tempUser.events) {
                    if (this.tempUser.events[x].status !== 8) {
                      this.tempUser.status = this.tempUser.events[x].status
                      break
                    }
                  }
                  this.tempUser.secession = null
                }
                this.tempUser.tyg = this.getLatestYCS(this.tempUser)
                this.loading = true
                this.updateStatus().then(() => {
                  vm.createEvents()
                  vm.loading = false
                })
                break
              }
            }
          } else if (value.action === 'change') {
            for (i in this.tempUser.events) {
              if (this.tempUser.events[i].id === value.event.id) {
                Vue.set(this.tempUser.events, i, value.event)
                if (value.event.status === 5) {
                  this.tempUser.admission = value.event.date1
                }
                this.tempUser.tyg = this.getLatestYCS(this.tempUser)
                this.loading = true
                this.updateStatus().then(() => {
                  vm.loading = false
                })
                break
              }
            }
          }
        }
        return
      }
      if (value && value.item !== null) {
        var index = this.tempUser.contacts.findIndex(contact => contact.id === value.item.id)
        if (index !== -1) {
          Vue.set(this.tempUser.contacts, index, value.item)
        } else {
          this.tempUser.contacts.push(value.item)
        }
      }
      this.dialog5 = false
      this.dialog6 = false
    },
    onGoto (path) {
      this.$nextTick(function () {
        this.goto(this, path)
      })
    },
    onClose () {
      this.$emit('dismissed')
    },
    getStatusColor () {
      if (this.tempUser.status === this.$STATUS_ADMISSION) {
        return 'success'
      }
      if (this.tempUser.status === this.$STATUS_LOSE) {
        return 'error'
      }
      if (this.tempUser.status === this.$STATUS_GRADUATION) {
        return 'warning'
      }
      return 'secondary'
    },
    onSuccessDialog: function (value) {
      this.tempItem = JSON.parse(JSON.stringify(value.item))
      this.admissionDialog = true
    },
    onDelete () {
      var vm = this
      this.loading = true
      this.tempUser.enable = false
      this.updateStatus().then(() => {
        vm.loading = false
        vm.onClose()
      })
    },
    onSuccess () {
      var vm = this
      this.event = this.tempItem
      this.tempUser.status = 5
      this.tempUser.admission = this.tempItem.date1
      this.admissionDialog = false
      this.loading = true
      this.storeEvent().then(() => {
        vm.tempUser.status = this.$STATUS_ADMISSION
        vm.updateStatus().then(() => {
          this.event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
          this.event.status = this.tempUser.status
          var temp = JSON.parse(JSON.stringify(this.tempUser))
          this.tempUser = null
          this.tempUser = temp
          vm.loading = false
        })
      })
    },
    onFail () {
      var vm = this
      var temp = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
      temp.id = this.tempUser.events.length + 1
      temp.grade = this.getGrade(this.tempUser)
      temp.status = this.$STATUS_LOSE
      temp.key = this.tempUser.key
      temp.charge = this.user.uid
      temp.createdAt = parseInt(new Date().getTime())
      this.event = temp
      var m = moment(new Date())
      moment.tz.setDefault('Asia/Tokyo')
      this.tempUser.secession = m.format('YYYY-MM-DD')
      this.tempUser.status = this.$STATUS_LOSE
      this.loading = true
      this.storeEvent().then(() => {
        vm.updateStatus().then(() => {
          this.event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
          vm.loading = false
        })
      })
    },
    onUpdateEvent: function (value) {
      this.event = JSON.parse(JSON.stringify(value.item))
      this.files = value.files
      if (value && value.group !== null) {
        var g = {}
        g[value.group] = true
        Vue.set(this.tempUser, 'groups', g)
      }
      this.isModifiedEvent = true
    },
    onEventSubmit: function (value) {
      var vm = this
      if (value) {
        this.event = JSON.parse(JSON.stringify(value))
        if (value.type === 6) {
          vm.tempUser.status = this.$STATUS_GRADUATION
          vm.tempUser.graduation = value.date1
        }
        if (value.type === 4) {
          vm.tempUser.tyg = value.tyg
        }
        vm.loading = true
        this.storeEvent().then(() => {
          vm.updateStatus().then(() => {
            vm.loading = false
            vm.event = JSON.parse(JSON.stringify(vm.$store.getters['students/event']))
            vm.event.status = vm.tempUser.status
          })
        })
      }
    },
    onStore: function (value) {
      var vm = this
      this.loading = true
      if (value) {
        this.event = JSON.parse(JSON.stringify(value.item))
      }
      this.storeEvent().then(() => {
        if (value && value.group !== null) {
          var g = {}
          g[value.group] = true
          Vue.set(this.tempUser, 'groups', g)
        }
        this.updateStatus().then(() => {
          vm.loading = false
          vm.isModifiedEvent = false
        })
      })
    },
    onNext: function (value) {
      this.loading = true
      this.isModifiedEvent = false
      this.event = JSON.parse(JSON.stringify(value.item))
      this.storeEvent().then(() => {
        Vue.set(this.tempUser, 'status', Number(this.tempUser.status) + 1)
        if (this.tempUser.status === 2) {
          var back = JSON.parse(JSON.stringify(this.tempUser))
          var g = {}
          g[value.group] = true
          back.groups = g
          this.tempUser = null
          this.tempUser = back
        }
        this.updateStatus().then(() => {
          const index = this.tempUser.events.findIndex(event => event.status === this.tempUser.status)
          if (index !== -1 && this.tempUser.events[index].enable) {
            this.event = this.tempUser.events[index]
          } else {
            this.event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
            this.event.status = this.tempUser.status
          }
          if (this.tempUser.status === 2) {
            var offset = this.tempUser.events.length - 1
            if (this.tempUser.events[offset].date1 != null) {
              if (this.event.date1 === null) {
                this.event.date1 = this.tempUser.events[offset].date1
              }
            }
            if (this.tempUser.events[offset].time1 != null) {
              if (this.event.time1 === null) {
                this.event.time1 = this.tempUser.events[offset].time1
              }
            }
          }
          if (this.tempUser.status === 3) {
            offset = this.tempUser.events.length - 1
            if (this.tempUser.events[offset].date2 != null) {
              if (this.event.date1 === null) {
                this.event.date1 = this.tempUser.events[offset].date2
              }
            }
            if (this.tempUser.events[offset].time2 != null) {
              if (this.event.time1 === null) {
                this.event.time1 = this.tempUser.events[offset].time2
              }
            }
          }
          this.loading = false
        })
      })
    },
    onPrev () {
      this.isModifiedEvent = false
      this.tempUser.status = Number(this.tempUser.status) - 1
      const index = this.tempUser.events.findIndex(event => event.status === this.tempUser.status)
      if (index !== -1) {
        this.event = this.tempUser.events[index]
      } else {
        this.event = JSON.parse(JSON.stringify(this.$store.getters['students/event']))
        this.event.status = this.tempUser.status
      }
      this.updateStatus()
    },
    fwrite (file) {
      var vm = this
      return new Promise((resolve) => {
        vm.$store.dispatch('storage/write', { blob: file.blob, child: 'students', id: vm.tempUser.key, uuid: vm.genUUIDv4() }).then(function (resp) {
          resolve(resp)
        })
      })
    },
    storeFiles () {
      var vm = this
      this.loading = true
      return new Promise((resolve) => {
        async.eachSeries(this.files, function (file, cb) {
          vm.fwrite(file).then(function (resp) {
            if (resp) {
              var payload = vm.event.attaches ? JSON.parse(JSON.stringify(vm.event.attaches)) : []
              payload.push({
                name: file.name,
                mime: file.mime,
                size: file.size,
                path: resp.path,
                thumbnail: resp.thumbnail
              })
              vm.event.attaches = payload
            }
            cb()
          })
        }, function (error) {
          if (error) {
          }
          vm.files = []
          vm.loading = false
          resolve()
        })
      })
    },
    storeEvent () {
      var vm = this
      return new Promise((resolve) => {
        this.storeFiles().then(function () {
          vm.event.grade = vm.getGrade(vm.tempUser)
          vm.event.status = vm.tempUser.status
          moment.tz.setDefault('Asia/Tokyo')
          var index = vm.tempUser.events.findIndex(event => event.id === vm.event.id)
          if (vm.event.status !== 1) {
            vm.event.updatedAt = parseInt(new Date().getTime())
          }
          if (index !== -1) {
            vm.event.counter += 1
            Vue.set(vm.tempUser.events, index, vm.event)
          } else {
            var temp = JSON.parse(JSON.stringify(vm.event))
            temp.id = vm.tempUser.events.length + 1
            temp.key = vm.tempUser.key
            temp.createdAt = parseInt(new Date().getTime())
            vm.event = temp
            temp = JSON.parse(JSON.stringify(vm.tempUser))
            vm.tempUser = null
            temp.events.unshift(vm.event)
            vm.tempUser = temp
          }
          vm.event.charge = vm.user.uid
          resolve()
        })
      })
    },
    updateStatus () {
      return new Promise((resolve) => {
        var payload = JSON.parse(JSON.stringify(this.$store.getters['students/initial']))
        var keys = Object.keys(payload)
        for (var i in keys) {
          payload[keys[i]] = this.tempUser[keys[i]]
        }
        if (payload.key === null) {
          payload['createdAt'] = parseInt(new Date().getTime())
        }
        payload['updatedAt'] = parseInt(new Date().getTime())
        this.$store.dispatch('students/write', JSON.parse(JSON.stringify(payload))).then((resp) => {
          resolve()
        })
      })
    },
    getSortIcon (item) {
      return this.sortIcons[this.headers[item].value]
    },
    onMouse (item, value) {
      this.headers[item].over = value
    },
    onSort (item) {
      var temp = this.headers[item].value += 1
      if (temp === 3) {
        temp = 0
      }
      for (var i in this.headers) {
        this.headers[i].value = 0
      }
      this.headers[item].value = temp
    }
  }
}
</script>

<style scoped>
.scroller {
  height: 100%;
}

.select-none {
  user-select: none;
}

.customHeader {
  cursor: pointer;
  user-select: none;
}

.customLine {
  cursor: pointer;
  user-select: none;
}

.customLine:hover {
  background-color: #CCCCCC20;
}

.sheet-footer-text {
  cursor: pointer;
}

.v-card__text.memo{
  cursor: pointer;
}

span.history {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  vertical-align: middle;
}

.b-B {
  border-bottom: 1px solid #4CAF50 !important;
  -moz-box-sizing: border-box;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}

.v-icon {
  user-select: none !important;
}

.sheet-footer-text {
  user-select: none !important;
}

</style>
